import {SettingsSdkKeys} from "../../models/settings"
import TextAlignment from "../../models/textAlignment"

const getTextAlignment = (configuration: any) => {
    if (!configuration) throw new Error("Settings Failure")
    if (configuration[SettingsSdkKeys.Direction]?.Value) {
        return configuration[SettingsSdkKeys.Direction].Value as TextAlignment
    }
    // Default fallback
    return TextAlignment.Ltr
}

export default getTextAlignment
